import React from "react";
import TransportationActions from "../../transportationActions/transportationActions";
import {RouteComponentProps, withRouter} from "react-router";
import {RouteParamsModel} from "../../../../common/models/routeParams";
import {Api} from "../../../../helpers/api";
import {HttpError} from "../../../../common/components/shared/httpError/httpError";
import i18n from "../../../../i18n/i18n";
import Loader from "../../../../common/components/shared/loader/loader";
import ReloadButton from "../../../../common/components/shared/reloadButton/reloadButton";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../../../common/models/httpError";
import {ReactComponent as InIcon} from "../../../../statics/icons/icon_in.svg";
import {ReactComponent as OutIcon} from "../../../../statics/icons/icon_out.svg";
import "./orderTcr.scss";
import TemperatureSection from "./temperatureSection/temperatureSection";
import Row from "../../../../common/components/shared/row/row";
import AdditionalEquipment from "./additionalEquipment/additionalEquipment";
import TrailerCondition from "./trailerCondition/trailerCondition";
import {storesContext} from "../../../../common/stores/stores";
import {ITcrStore} from "../../../stores/tcrStore";
import {observer} from "mobx-react";
import {OrderService} from "../../../services/orderService";
import {Direction} from "../../../models/transport";
import PdfLink from "../../../../common/components/shared/pdfLink/pdfLink";
import TcrReportFile from "./pdfFile/tcrReportFile";
import {IUserStore} from "../../../../administration/stores/userStore";
import {ReactComponent as DownloadIcon} from "../../../../statics/icons/icon_downloadReport.svg";
import {OrderFilesUtils} from "../../../../helpers/orderFilesUtils";
import {TcrService} from "../../../services/tcrService";
import {IOrderStore} from "../../../stores/orderStore";

interface OrderTcrState {
    isExport: boolean;
    responseTcrData: AxiosResponse<HttpErrorModel[] | any> | undefined;
    responseOrder: AxiosResponse<HttpErrorModel[] | any> | undefined;
}

interface OrderTcrProps extends RouteComponentProps {
    isUpdate: false | boolean;
    response: AxiosResponse<HttpErrorModel[] | any> | undefined;
}

class OrderTcr extends React.Component <OrderTcrProps, OrderTcrState> {
    static contextType = storesContext;

    constructor(props: any) {
        super(props);

        this.state = {
            isExport: false,
            responseTcrData: this.props.response,
            responseOrder: undefined
        };
    }

    async componentDidMount() {
        const params = this.props.match.params as RouteParamsModel;
        const orderId = params.id || "";

        await this.setOrderData(orderId);
        await this.setTcrData(orderId);
    }

    componentWillUnmount() {
        this.context.tcrStore.clearDataForFile();
        this.context.tcrStore.setIsAddDamages(false);
    }

    public render(): JSX.Element {
        const tcrStore = this.context.tcrStore as ITcrStore;
        const orderStore = this.context.orderStore as IOrderStore;
        const orderId = tcrStore.orderId || "";

        return (
            <div className="transportation-order-tcr">
                <div className="content transportation-order-content">
                    <TransportationActions
                        orderId={orderId}
                        element="order"
                        relationType={orderStore.relationType.value}
                    />
                    {this.renderContent()}
                </div>
            </div>
        );
    }

    private renderContent(): JSX.Element {
        const tcrStore = this.context.tcrStore as ITcrStore;

        if (!Api.isSuccess(this.state.responseTcrData)) {
            return <HttpError
                response={this.state.responseTcrData}
                cause={i18n.t("transportation.order.tcr.retrievalErrorSuffix")}
            />;
        } else if (!Api.isSuccess(this.state.responseOrder)) {
            return <HttpError
                response={this.state.responseOrder}
                cause={i18n.t("transportation.order.tcr.retrievalErrorSuffix")}
            />;
        } else if ((this.state.responseTcrData && this.state.responseOrder) || tcrStore.isAddDamages) {
            return this.renderTcr();
        } else {
            return (
                <Loader/>
            );
        }
    }

    private renderTcr(): JSX.Element {
        return (
            <div className="transportation-order-tcr-sub-content">
                {this.renderHeader()}
                <TrailerCondition isUpdate={this.props.isUpdate}/>
                <div className="section depo-section">
                    {this.renderDepoInSection()}
                    {this.renderDepoOutSection()}
                </div>
            </div>
        );
    }

    private renderHeader(){
        const tcrStore = this.context.tcrStore as ITcrStore;
        const userStore = this.context.userStore as IUserStore;
        const orderId = tcrStore.orderId || "";

        return (
            <div className="header" data-testid="header">
                {i18n.t("transportation.order.tcr.header", {number: orderId})}
                <div className="actions-button">
                    {userStore.canPrintTcrFile && (
                        <div className="print-button">
                            <PdfLink
                                document={<TcrReportFile isExport={this.state.isExport} tcrStore={tcrStore}/>}
                                fileName={i18n.t("transportation.order.tcr.file.fileName", {number: tcrStore.orderId})}
                                buttonText={i18n.t("transportation.order.tcr.file.button")}
                                buttonVariant="outlined"
                                responseFile={this.state.responseTcrData}
                                endIcon={<DownloadIcon/>}
                                testId="tcr-report-file"
                                disabed={tcrStore.isEdit}
                            />
                        </div>
                    )}
                    <ReloadButton
                        reloadFunc={this.reload.bind(this)}
                        testId={"order-tcr-reload-btn"}
                    />
                </div>
            </div>
        );
    }
    private renderDepoInSection(): JSX.Element {
        return (
            <Row class="additional-equipment-and-temperature-section">
                <AdditionalEquipment
                    type="entry"
                    icon={<InIcon/>}
                    isUpdate={this.isUpdateSection(Direction.IN)}
                />
                <TemperatureSection
                    type="entry"
                    icon={<InIcon/>}
                    isUpdate={this.isUpdateSection(Direction.IN)}
                />
            </Row>
        );
    }

    private renderDepoOutSection(): JSX.Element {
        return (
            <Row class="additional-equipment-and-temperature-section">
                <AdditionalEquipment
                    type="exit"
                    icon={<OutIcon/>}
                    isUpdate={this.isUpdateSection(Direction.OUT)}
                />
                <TemperatureSection
                    type="exit"
                    icon={<OutIcon/>}
                    isUpdate={this.isUpdateSection(Direction.OUT)}
                />
            </Row>
        );
    }

    private async reload() {
        const tcrStore = this.context.tcrStore as ITcrStore;
        const orderId = tcrStore.orderId || "";

        tcrStore.setTcr(undefined);
        tcrStore.setIsEdit(false);
        await this.setTcrDataFromApi(tcrStore, orderId);
    }

    private isUpdateSection(direction: Direction) {
        const tcrStore = this.context.tcrStore as ITcrStore;

        return this.props.isUpdate && tcrStore.direction === direction;
    }

    private async setOrderData(orderId: string) {
        const tcrStore = this.context.tcrStore as ITcrStore;
        const orderStore = this.context.orderStore as IOrderStore;

        const responseOrder = await OrderService.getOrder(orderId);

        tcrStore.setOrderData(responseOrder?.data);
        orderStore.relationType.setValue(Api.isSuccess(responseOrder) ? responseOrder!.data?.relationType : "");

        this.setState({
            isExport: OrderFilesUtils.isExportRelationType(responseOrder?.data?.relationType)
        });

        this.setState({responseOrder});
    }

    private async setTcrData(orderId: string) {
        const tcrStore = this.context.tcrStore as ITcrStore;

        if(!this.props.isUpdate || !tcrStore.isAddDamages) {
            await this.setTcrDataFromApi(tcrStore, orderId);
        }
    }

    private async setTcrDataFromApi(tcrStore: ITcrStore, orderId: string) {
        const responseTcrData = await TcrService.getTcr(orderId);
        tcrStore.setTcr(Api.isSuccess(responseTcrData) ? responseTcrData?.data : null);

        this.setState({responseTcrData});
    }
}

export default withRouter(observer(OrderTcr));